import { Component } from '@verndale/core';
import Dropdown from '../components/dropdown';

class DetailsLocations extends Component {
  setupDefaults() {
    this.dom = {
      dropdown: this.el.querySelector('.location-dropdown')
    };

    if (this.dom.dropdown) {
      new Dropdown(this.dom.dropdown);
    }
  }

  addListeners() {
    if (!this.dom.dropdown) {
      return;
    }
    this.dom.dropdown.addEventListener('change', ::this.handleChange);
  }

  handleChange() {
    const selectValue = this.dom.dropdown.value;
    window.location = selectValue;
  }

}

export default DetailsLocations;
